import firebase from '@/firebase'
// const db = firebase.db

const state = {}

const getters = {}

const actions = {
  exportModel (context, payload) {
    return new Promise((resolve, reject) => {
      firebase.functions.httpsCallable('api-exportModel')({ targetEnv: 'ngapp5-dev', modelId: 'Citigroup-Bana-MEX', modelType: 'mmm' }).then(function (result) {
        resolve(result)
      }).catch(function (error) {
        reject(error)
      })
    })
  }
}

const mutations = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
